

import { IPLUS_TABLE } from './types';

/**
 * Code generated from @lazy-cjk/jp-table-comparison/lib/table/core.ts;
 * DO NOT EDIT.
 * @see {@link ./table/core.ts}
 */

export const PLUS_TABLE: IPLUS_TABLE = [
	["箋","箋","笺"],
	["駄","馱","驮"],
	["専","專","专"],
	["絲","絲","丝"],
	["並","並","并"],
	["傑","傑","杰"],
	["氷","冰","冰"],
	["決","決","决"],
	["凄","淒","凄"],
	["凄","悽","凄"],
	["准","準","准"],
	["準","準","准"],
	["画","劃","划"],
	["刹","剎","刹"],
	["効","效",null],
	["歴","歷","历"],
	["暦","曆","历"],
	["圧","壓","压"],
	["鹹","鹹","咸"],
	["圏","圈","圈"],
	["殻","殻","壳"],
	["宮","宮","宫"],
	["秘","祕","秘"],
	["異","異","异"],
	["棄","棄","弃"],
	["強","強","强"],
	["恒","恆","恒"],
	["抜","拔",null],
	["揷","插","插"],
	["晩","晚","晚"],
	["槍","槍","枪"],
	["沢","澤","泽"],
	["錬","鍊","炼"],
	["煙","煙","烟"],
	["甦","甦","苏"],
	["蓋","蓋","盖"],
	["穀","穀","谷"],
	["窓","窗","窗"],
	["罵","罵","骂"],
	["館","館","馆"],
	["蝕","蝕","蚀"],
	["詛","詛","诅"],
	["誰","誰","谁"],
	["謎","謎","谜"],
	["貪","貪","贪"],
	["賎","賤","贱"],
	["贓","贓","赃"],
	["踪","蹤","踪"],
	["踪","踪","踪"],
	["鶏","雞","鸡"],
	["静","靜","静"],
	["髪","髮",null],
	["鶫","鶇","鸫"],
	["鶇","鶇","鸫"],
	["黙","默","默"],
];

/**
 * Code generated from @lazy-cjk/jp-table-comparison/lib/table/core.ts;
 * DO NOT EDIT.
 * @see {@link ./table/core.ts}
 */

export const PLUS_TABLE_SAFE: IPLUS_TABLE = [
	["弐","貳","贰"],
	["別","別","别"],
	["巻","卷","卷"],
	["蘇","蘇","苏"],
	["挿","插","插"],
	["絶","絕","绝"],
	["隷","隸","隶"],
	["魯","魯","鲁"],
];

